/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Italian (it) string table — Shop landing page
   English is the source of truth in the HTML; this file supplies the
   Italian counterpart for each shop.* key. Missing keys fall back to
   English (see i18n.js). Claim-bearing copy: faithful renderings only,
   no strengthening or embellishment. The only standing discount is the
   routine-builder 10% (auto-applied at checkout for 2+ serums).

   House voice: calm, exact, short. No em dashes in prose (use periods,
   commas, or the mid-dot · ). EXCEPTION: combo card labels keep the
   existing em dash ("Serum C — Brightening"), mirrored faithfully.
   Informal "tu". Product names, prices and proper nouns stay as-is.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.it = window.TD_I18N.it || {};
  Object.assign(window.TD_I18N.it, {

    /* ── Nav (page-specific) ── */
    'shop.nav.build': 'Costruisci una routine',

    /* ── Serum grid ── */
    'shop.grid.title': 'Cura della pelle senza compromessi',
    'shop.addcart': 'Aggiungi al carrello',
    'shop.time.day': 'Giorno',
    'shop.time.night': 'Notte',
    'shop.time.both': 'Giorno e notte',
    'shop.card.c.benefit': 'Protegge, illumina e rassoda con vitamina C pura.',
    'shop.card.a.benefit': 'Rinnovamento guidato dal retinolo mentre dormi.',
    'shop.card.o.benefit': 'Dà energia alle cellule e restituisce luminosità visibile.',
    'shop.card.m.benefit': 'Ripara la barriera di idratazione. In profondità e nel tempo.',
    'shop.card.r.benefit': 'Rassoda e ripristina. Riduce le imperfezioni e la texture disomogenea nel tempo.',

    /* ── Benefit strip ── */
    'shop.strip.1.t': 'Senza conservanti',
    'shop.strip.1.b': 'Packaging airless e resistente ai raggi UV che protegge ogni attivo. Niente stabilizzanti, nessun compromesso.',
    'shop.strip.2.t': 'Rilascio transdermico',
    'shop.strip.2.b': 'Un sistema di trasporto senza acqua porta le vitamine attive oltre la superficie fino al derma, dove avvengono la sintesi del collagene e il rinnovamento cellulare.',
    'shop.strip.3.t': '2 anni di conservazione',
    'shop.strip.3.b': 'Niente acqua significa niente crescita batterica. Stabile e potente dal primo utilizzo all\'ultimo.',
    'shop.strip.4.t': 'Cruelty-free',
    'shop.strip.4.b': 'Mai testato sugli animali. Sviluppato clinicamente, consegnato in modo responsabile.',

    /* ── Combo builder ── */
    'shop.combo.label': 'Costruisci la tua routine',
    'shop.combo.h2': 'Due sieri o più?<br><em>Dieci per cento di sconto.</em>',
    'shop.combo.c.name': 'Serum C — Luminosità',
    'shop.combo.c.desc': 'Vitamina C · Giorno · Macchie scure e luminosità',
    'shop.combo.a.name': 'Serum A — Rinnovamento',
    'shop.combo.a.desc': 'Vitamina A · Notte · Rinnovamento cellulare e texture',
    'shop.combo.o.name': 'Serum O — Ossigenante',
    'shop.combo.o.desc': 'Vitamina O · Giorno · Vitalità cellulare e tono',
    'shop.combo.m.name': 'Serum M — Idratazione',
    'shop.combo.m.desc': 'Vitamina M · Giorno + notte · Idratazione e barriera',
    'shop.combo.r.name': 'Serum R — Antiossidante',
    'shop.combo.r.desc': 'Resveratrolo · Giorno + notte · Protezione e longevità',

    /* ── Combo summary sidebar ── */
    'shop.concern.label': 'Acquista per esigenza della pelle',
    'shop.concern.placeholder': 'Scegli un\'esigenza…',
    'shop.concern.firmness': 'Tonicità',
    'shop.concern.brightness': 'Luminosità',
    'shop.concern.hydration': 'Idratazione',
    'shop.concern.finelines': 'Linee sottili',
    'shop.concern.darkspots': 'Macchie scure',
    'shop.concern.texture': 'Texture',
    'shop.concern.acnescars': 'Cicatrici da acne',
    'shop.concern.dullness': 'Pelle spenta',
    'shop.sum.title': 'La tua routine',
    'shop.sum.empty': 'Scegli i sieri per iniziare',
    'shop.sum.discount': 'Sconto routine (10%)',
    'shop.sum.total': 'Totale',
    'shop.sum.addbtn': 'Aggiungi la routine al carrello',
    'shop.sum.note': 'Spedizione gratuita in tutto il mondo · 2 anni di conservazione garantiti',

    /* ── Sample / Discovery Kit ── */
    'shop.samp.eyebrow': 'Non sai da dove iniziare?',
    'shop.samp.title': 'Prova tutti e cinque<br><em>per $70.</em>',
    'shop.samp.body': 'Il Transderma Discovery Kit contiene formati tascabili di tutti e cinque i sieri. È così che la maggior parte dei nostri clienti di lunga data ci ha scoperti.',
    'shop.samp.cta': 'Prendi il Discovery Kit',
    'shop.samp.fine': '$5 di spedizione in tutto il mondo · Spedito da Stoccolma',
    'shop.samp.f1.t': 'Tutti e cinque i sieri',
    'shop.samp.f1.b': 'Formati tascabili di C, A, O, M e R, 3 ml ciascuno. Circa 7 giorni di uso costante per flacone.',
    'shop.samp.f2.t': 'Tutti e cinque, fianco a fianco',
    'shop.samp.f2.b': 'Fai passare ogni formula nella tua routine la stessa settimana e trova le combinazioni che funzionano per la tua pelle.',
    'shop.samp.f3.t': 'Nessun impegno',
    'shop.samp.f3.b': 'In una settimana saprai se Transderma fa per te. La maggior parte lo sa in pochi giorni.',

    /* ── Gift voucher ── */
    'shop.gift.title': 'Regala <em>Transderma</em>',
    'shop.gift.sub': 'Un buono digitale consegnato via e-mail. Spendibile su ogni siero e sul Discovery Kit.',
    'shop.gift.btn': 'Acquista ora',

    /* ── Discovery Kit product page (shopify-theme/templates/product.transderma-discovery-kit.liquid) ── */
    'shop.kit.crumb.home': 'Home',
    'shop.kit.crumb.current': 'Discovery Kit',

    /* Hero */
    'shop.kit.eyebrow': 'Cinque sieri vitaminici · Un kit',
    'shop.kit.tagline': 'Formati tascabili di tutti e cinque i sieri Transderma. Circa 7 giorni di uso quotidiano per l\'intero kit. Prova il sistema completo prima di scegliere i flaconi formato pieno.',
    'shop.kit.price.meta': 'Cinque mini-flaconi · 3 ml ciascuno',
    'shop.kit.addcart': 'Aggiungi al carrello · $70',
    'shop.kit.soldout': 'Esaurito · presto di nuovo disponibile',
    'shop.kit.reserve': 'Prenota il tuo kit',

    /* Hero meta */
    'shop.kit.meta.inside': 'Cosa include',
    'shop.kit.meta.inside.v': '5 mini-flaconi · 3 ml ciascuno',
    'shop.kit.meta.lasts': 'Dura',
    'shop.kit.meta.lasts.v': '~7 giorni di uso quotidiano',
    'shop.kit.meta.formula': 'Formula',
    'shop.kit.meta.formula.v': '100% attivo, senza acqua',
    'shop.kit.meta.shelf': 'Conservazione',
    'shop.kit.meta.shelf.v': '2 anni, potente per tutto il tempo',

    /* What's inside */
    'shop.kit.inside.label': 'Cosa include',
    'shop.kit.inside.title': 'Cinque mini-flaconi.<br><em>Una routine completa.</em>',
    'shop.kit.inside.intro': 'Ogni mini-flacone contiene siero a sufficienza per circa 7 giorni di applicazione quotidiana. Usali separatamente, stratificali mattina e sera, o prova combinazioni in base alle tue esigenze.',
    'shop.kit.card.time.day': 'Giorno',
    'shop.kit.card.time.night': 'Notte',
    'shop.kit.card.time.both': 'Giorno + notte',
    'shop.kit.card.c.desc': 'Vitamina C pura. Illumina, protegge, uniforma il tono.',
    'shop.kit.card.a.desc': 'Retinolo. Rinnovamento cellulare e texture, mentre dormi.',
    'shop.kit.card.o.desc': 'PQQ. Energia cellulare, vitalità, chiarezza.',
    'shop.kit.card.m.desc': 'Acido ialuronico. Idratazione, pienezza, supporto alla barriera.',
    'shop.kit.card.r.desc': 'Resveratrolo. Difesa antiossidante e longevità.',

    /* Why try the kit */
    'shop.kit.why.label': 'Perché iniziare da qui',
    'shop.kit.why.title': 'Trova la tua routine <em>prima</em> di impegnarti.',
    'shop.kit.why.intro': 'Un flacone formato pieno costa $175 e dura diverse settimane di uso quotidiano. Il Discovery Kit è il modo più semplice per scoprire quali sieri funzionano sulla tua pelle, e quali combinazioni fanno davvero la differenza per le tue esigenze specifiche.',
    'shop.kit.why.1.t': '~7 giorni di uso reale.',
    'shop.kit.why.1.b': 'Siero a sufficienza per applicare mattina e sera per circa una settimana e iniziare a vedere cambiamenti in texture, tono e idratazione. Questo non è un campione, è una routine in atto.',
    'shop.kit.why.2.t': 'Tutti e cinque, fianco a fianco.',
    'shop.kit.why.2.b': 'Fai passare ogni formula nella tua routine del mattino e della sera nella stessa settimana. Il kit è il modo più rapido per imparare quali combinazioni fanno davvero la differenza per la tua pelle.',
    'shop.kit.why.3.t': 'Tutti e cinque per meno di mezzo flacone.',
    'shop.kit.why.3.b': 'Un singolo siero Transderma formato pieno costa $175. Il kit ti dà tutti e cinque per $70: il modo più economico per scoprire a quali formule la tua pelle risponde davvero prima di decidere.',

    /* How it works */
    'shop.kit.how.label': 'Come funziona',
    'shop.kit.how.title': 'Sette giorni. <em>Una scoperta.</em>',
    'shop.kit.how.intro': 'La maggior parte dei clienti lo sa in cinque giorni. Ecco il percorso che la maggior parte segue.',
    'shop.kit.how.s1.t': 'Giorno 1 · Apri',
    'shop.kit.how.s1.b': 'Apri il kit. Scegli l\'esigenza che corrisponde alla tua: luminosità, rinnovamento o idratazione.',
    'shop.kit.how.s2.t': 'Giorni 1–3 · Prova',
    'shop.kit.how.s2.b': 'Applica la tua routine mattina e sera. Due gocce, pressate sulla pelle pulita. Lascia che ogni strato si assorba per 30 secondi.',
    'shop.kit.how.s3.t': 'Giorni 4–7 · Affina',
    'shop.kit.how.s3.b': 'Entro il settimo giorno saprai a quali sieri la tua pelle risponde. Cambia routine, stratifica diversamente o semplifica a due.',
    'shop.kit.how.s4.t': 'Giorno 8 · Aumenta',
    'shop.kit.how.s4.b': 'Ordina flaconi formato pieno dei sieri che hanno funzionato, nella routine che hai costruito. Due flaconi o più = 10% di sconto.',

    /* Delivery / returns */
    'shop.kit.del.shipping.t': 'Spedizione',
    'shop.kit.del.shipping.b': 'Tariffa unica di $5 di spedizione in tutto il mondo. Spedito da Stoccolma, di solito 3–7 giorni lavorativi. <a href="/pages/shipping-returns">Dettagli completi sulla spedizione</a>.',
    'shop.kit.del.returns.t': 'Resi',
    'shop.kit.del.returns.b': 'Una volta aperto, il Discovery Kit non è rimborsabile. I kit non aperti possono essere restituiti entro 14 giorni. <a href="/pages/shipping-returns">Politica di reso</a>.',
    'shop.kit.del.approved.t': 'Approvato e registrato',
    'shop.kit.del.approved.b': 'Approvato in laboratorio da Läkemedelsverket. Registrato in conformità con la Legislazione Europea sui Cosmetici. Mai testato sugli animali.'

  });
})();
